import React, { useState, useEffect, useRef } from 'react'

import DialogPrompt from 'components/DialogPrompt'

import useFetchData from 'hooks/fetch-data'
import reactFLow from 'Services/react-flow'
import { Toast } from 'Snackbar/useToast'

import { get, isEmpty } from 'lodash'
import $ from 'jquery'
import Edit from '../onboarding/edit'
import onBoardingWorkorder from 'Services/WorkOrder/on-boarding-wo'
import usePostData from 'hooks/post-data'
import enums from 'Constants/enums'

const SingleLine = ({ woId, isOnboarding, classCodeOptions, tempBuildings, woData, addingAssetLocation, isQuote, handleAssetNodeClick, reload }) => {
  const [nodeData, setNodeData] = useState({ list: [], initialEdges: [] })
  const [flowKey, setFlowKey] = useState(0)
  const [recivedObj, setRecivedObj] = useState(null)
  const [deleteLoading, setDeleteLoading] = useState(false)
  const recivedObjRef = useRef(null)

  useEffect(() => {
    recivedObjRef.current = recivedObj
  }, [recivedObj])

  const handleFormatter = data => {
    const subClassCodes = [
      'LAAR',
      'SPRT-LV',
      'BESS',
      'NICB',
      'VLAB',
      'VRLB',
      'PCAP',
      'SCAP',
      'AMCB',
      'CTCR',
      'ARCB',
      'GICB',
      'ICCB',
      'LVCB',
      'MCCB-L-LV',
      'MCCB-S-LV',
      'OICB',
      'RCLS',
      'VCCB',
      'FUSE-LV',
      'FUSE-MV',
      'BNDG',
      'GRND',
      'CITR',
      'PITR',
      'AMME',
      'LIMI',
      'MMME',
      'VVME',
      'WHME',
      'FUEL',
      'Other',
      'EMRE',
      'MPRE',
      'SSRE',
      'BISW-LV',
      'BISW-MV',
      'BPSW',
      'DISC-F-LV',
      'DISC-F-MV',
      'DISC-LV',
      'DISC-MV',
      'HPSW',
      'LISW',
    ]
    const { list = [], initialEdges = [] } = data

    const subcomponents = list.filter(item => item.extent === 'parent' && subClassCodes.includes(item.data.code))
    const topLevelComponents = list.filter(item => item.extent === null)
    const combinedList = [...topLevelComponents, ...subcomponents]
    setNodeData(!isEmpty(combinedList) ? { list: combinedList, initialEdges } : { list: [], initialEdges: [] })
  }

  const { reFetch } = useFetchData({ fetch: reactFLow.workorder.get, payload: woId, formatter: d => handleFormatter(get(d, 'data', null)), externalLoader: true })

  const handleRefetch = res => {
    const currentRecivedObj = recivedObjRef.current
    if (!currentRecivedObj?.isOriantation) {
      if (!isEmpty(res)) {
        if (res.success > 0 && currentRecivedObj?.isDeleteEdges) {
          Toast.success('Edges Deleted Successfully!')
        } else if (res.success === -63) {
          if (currentRecivedObj?.isDeleteEdges) Toast.info('Cannot delete this edge')
        } else if (res.success > 0) {
          Toast.success('Edges Updated Successfully!')
        } else if (res.success === -62) {
          Toast.error('Unable to add this connection — it would create a loop.')
        } else if (res.success === -2) {
          Toast.error('Cannot delete main asset edges!')
        } else if (res.success < 0) {
          Toast.error('Something went wrong!')
        }
      }
      setNodeData({ list: [], initialEdges: [] })
      reFetch()
      setFlowKey(prevKey => prevKey + 1)
    } else {
      setRecivedObj({ ...currentRecivedObj, isOriantation: false })
    }
  }

  useEffect(() => {
    if (reload > 0) {
      handleRefetch()
    }
  }, [reload])

  const handleDataChange = async updatedData => {
    $('#pageLoading').show()
    setNodeData({ list: [], initialEdges: [] })
    const recivedData = [...updatedData.changedNodes]
    const newData = recivedData.map(d => ({
      assetId: !d.isTempAsset ? get(d, 'id', null) : null,
      woonboardingassetsId: d.isTempAsset ? get(d, 'id', null) : null,
      xAxis: Math.round(get(d, 'position.x', 0)),
      yAxis: Math.round(get(d, 'position.y', 0)),
    }))

    const res = await reactFLow.workorder.updatePosition({ assets: [...newData], edges: [], woId })
    if (res.success > 0) {
      Toast.success('Assets Positions Updated Successfully!')
      handleRefetch()
    } else if (res.success == -2) {
      Toast.success('You have not made any position changes')
      handleRefetch()
    } else {
      Toast.error('Something Went Wrong')
    }
    $('#pageLoading').hide()
  }

  const { mutate: updateEdges } = usePostData({ executer: reactFLow.workorder.updatePosition, postSuccess: res => handleRefetch(res), hideMessage: true })
  const submitData = async updateEdgesPayload => updateEdges(updateEdgesPayload)

  useEffect(() => {
    const onDataChangeHandler = event => {
      const { detail: updatedData } = event
      handleDataChange(updatedData)
    }
    const onSingleChangeHandler = event => {
      const { detail: updatedData } = event
      setRecivedObj(updatedData)

      if (updatedData.isEditing) {
        if (updatedData.changeData.isTempAsset) {
          $('#pageLoading').show()
          handleAssetNodeClick('EDIT', updatedData.changeData.id)
        } else {
          window.open(`${window.location.origin}/assets/details/${updatedData.changeData.id}`, '_blank')
        }
      } else if (updatedData.isAddingLineSide && updatedData.changeData.isTempAsset) {
        Toast.info('You cannot add a line or load-side subcomponent directly in the work order. If you want to add it, please add it through the top-level component')
      } else {
        if (!updatedData.changeData?.isTempAsset && !updatedData.isAdding && !updatedData.deleteObj?.isTempAsset && !updatedData.isDeleteEdges && !updatedData.isEdgesChange && !updatedData.isOriantation) {
          Toast.info('Would you like to modify this asset? If so, please add it as an existing asset.')
        }
      }

      if (updatedData.isEdgesChange) {
        if (woData.woStatusId === enums.woTaskStatus.Complete) {
          Toast.info('You cannot perform any actions on the single-line view from the Completed Work Order.')
          return
        }
        const wrongId = updatedData.changeData.id?.split('_')[0]
        submitData({
          assets: [],
          edges: [
            {
              id: wrongId === 'xy-edge' ? null : get(updatedData, 'changeData.id', null),
              source: get(updatedData, 'changeData.source', '00000000-0000-0000-0000-000000000000'),
              target: get(updatedData, 'changeData.target', '00000000-0000-0000-0000-000000000000'),
              targetHandle: get(updatedData, 'changeData.targetHandle', null),
              isDeleted: false,
              label: get(updatedData, 'changeData.label', ''),
              style: JSON.stringify(get(updatedData, 'changeData.style', '')),
              fedbyDetailsJson: !isEmpty(updatedData.changeData.data) ? JSON.stringify(get(updatedData, 'changeData.data', '')) : null,
            },
          ],
          woId,
        })
      }

      if (updatedData.isDeleteEdges) {
        submitData({
          assets: [],
          edges: [
            {
              id: get(updatedData, 'changeData', null),
              isDeleted: true,
            },
          ],
          woId,
        })
      }
      if (updatedData.isOriantation) {
        const oriantationData = updatedData.changeData.map(d => ({
          assetId: !d.isTempAsset ? get(d, 'id', null) : null,
          woonboardingassetsId: d.isTempAsset ? get(d, 'id', null) : null,
          xAxis: Math.round(get(d, 'position.x', 0)),
          yAxis: Math.round(get(d, 'position.y', 0)),
          assetOrientation: get(d, 'oriantation', null),
        }))
        submitData({ assets: oriantationData, edges: [] })
      }
    }
    document.addEventListener('datachange', onDataChangeHandler)
    document.addEventListener('singlechange', onSingleChangeHandler)
    return () => {
      document.removeEventListener('datachange', onDataChangeHandler)
      document.removeEventListener('singlechange', onSingleChangeHandler)
    }
  }, [])

  const formConfigs = [
    {
      condition: get(recivedObj, 'isAdding', false),
      props: {
        isOnboarding,
        viewObj: {},
        open: get(recivedObj, 'isAdding', false),
        onClose: () => setRecivedObj({ isAdding: false }),
        afterSubmit: handleRefetch,
        isNew: true,
        classCodeOptions,
        workOrderID: woId,
        workOrderNumber: woData.manualWoNumber,
        buildingOptions: tempBuildings,
        fixedLocations: addingAssetLocation,
        photosType: { cameraType: woData.irVisualCameraType, imageType: woData.irVisualImageType },
        isQuote,
        irImageCount: woData.irImageCount,
        nodePosition: get(recivedObj, 'changeData', null),
        isInstalling: woData.woType === enums.woType.Maintainance ? true : false,
        isWorkProcedure: woData.woType === enums.woType.Maintainance ? true : false,
      },
    },
    {
      condition: get(recivedObj, 'isAddingDownstream', false),
      props: {
        isOnboarding,
        viewObj: {},
        open: get(recivedObj, 'isAddingDownstream', false) && get(recivedObj, 'changeData.isTempAsset', false),
        onClose: () => setRecivedObj({ isAdding: false }),
        afterSubmit: handleRefetch,
        isNew: true,
        classCodeOptions,
        workOrderID: woId,
        workOrderNumber: woData.manualWoNumber,
        buildingOptions: tempBuildings,
        fixedLocations: addingAssetLocation,
        photosType: { cameraType: woData.irVisualCameraType, imageType: woData.irVisualImageType },
        isQuote,
        irImageCount: woData.irImageCount,
        nodePosition: get(recivedObj, 'changeData.position', null),
        downStreamData: get(recivedObj, 'changeData', null),
        isInstalling: woData.woType === enums.woType.Maintainance ? true : false,
        isWorkProcedure: woData.woType === enums.woType.Maintainance ? true : false,
      },
    },
  ]
  const handleDeleteNodeAsset = async () => {
    setDeleteLoading(true)
    try {
      const res = await onBoardingWorkorder.deleteAsset({ woonboardingassets_id: get(recivedObj, 'changeData', null) })
      if (res.success > 0) Toast.success(`Asset Deleted Successfully !`)
      else Toast.error(res.message)
    } catch (error) {
      Toast.error(`Error deleting Asset. Please try again !`)
    }
    setDeleteLoading(false)
    handleRefetch()
    setRecivedObj({ isDeleting: false })
  }

  return (
    <>
      <react-flow key={flowKey} initialdata={JSON.stringify(nodeData)} customheight={JSON.stringify(229)} isworkordercomplete={woData.woStatusId === enums.woTaskStatus.Complete ? JSON.stringify(true) : JSON.stringify(false)} />
      {formConfigs.map(({ condition, props }, index) => condition && <Edit key={index} {...props} />)}
      {get(recivedObj, 'isDeleting', false) && get(recivedObj, 'deleteObj.isTempAsset', false) && (
        <DialogPrompt title='Delete Asset' text='Are you sure you want to delete this Asset ?' open={get(recivedObj, 'isDeleting', false)} ctaText='Delete' actionLoader={deleteLoading} action={handleDeleteNodeAsset} handleClose={() => setRecivedObj({ isDeleting: false })} />
      )}
    </>
  )
}

export default SingleLine
